module.exports = __webpack_public_path__ + "img/close-sm.0d5be4d8.svg";